import actionTypes from './actionTypes';
import api, { createAuthenticatedApiInstance } from 'src/utils/api';
import { setAlert } from 'src/components/alert/actions';
import { closeModal, setModalProps }  from 'src/modules/shared/modal/actions';
import { captureException } from '@sentry/nextjs';
import i18n from 'src/utils/translate';
import { pluralize } from 'src/utils/string';
import FollowSuccessMessage from 'src/modules/community/shared/components/alert/followSuccessMessage';

export function followCommunity({ community, userId, silent = false }) {
  return async (dispatch) => {
    dispatch({ type: actionTypes.FOLLOW_COMMUNITY });
    try {
      await api.post(`private/communities/${community.slug}/follow/${userId}`);

      if (!silent) {
        dispatch(setAlert(FollowSuccessMessage({ communityName: community.name }), 'success'));
      }
      dispatch({
        type: actionTypes.FOLLOW_COMMUNITY_SUCCESS,
        community,
      });
    } catch (ex) {
      captureException(ex);
      dispatch(setAlert(ex.message));
      return dispatch({ type: actionTypes.FOLLOW_COMMUNITY_FAILURE, error: ex });
    }
  };
}

export function unfollowCommunity(community, userId, successMessage, noClose = false) {
  return async (dispatch) => {
    dispatch({ type: actionTypes.UNFOLLOW_COMMUNITY });
    try {
      await api.del(`private/communities/${community.slug}/follow/${userId}`);

      dispatch({
        type: actionTypes.UNFOLLOW_COMMUNITY_SUCCESS,
        communityId: community.communityId,
        slug: community.slug,
      });
      if (noClose) return;
      dispatch(closeModal());
      dispatch(setAlert(successMessage, 'success'));
    } catch (ex) {
      captureException(ex);
      dispatch({ type: actionTypes.UNFOLLOW_COMMUNITY_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
}

export const sendInvites = (communitySlug, emails) => async (dispatch, getState) => {
  try {
    const api = createAuthenticatedApiInstance(getState);
    const { data: { invitesSent: successful, failedValidation: invalid } } = await api.post(`private/communities/${communitySlug}/invites`, { emails });

    if (successful.length > 0) {
      dispatch(setAlert(pluralize(i18n.t('%1$s invite sent!'), i18n.t('%1$s invites sent!'), successful.length), 'success'));
    }
    if (successful.length === emails.length) {
      dispatch(closeModal());
    } else {
      dispatch(setModalProps({ successful, invalid }));
    }
  } catch (ex) {
    captureException(ex);
    dispatch(setAlert(ex.message));
  }
};

export const fetchCommunityTopics = (communitySlug) => {
  return async (dispatch) => {
    dispatch({ type: actionTypes.FETCH_COMMUNITY_TOPICS });
    try {
      const { data } = await api.getPublic(`topics/${communitySlug}`);
      const topics = data.map(topic => ({
        id: topic.topicId,
        name: topic.name,
        postCount: topic.postCount,
      }));

      dispatch({
        type: actionTypes.FETCH_COMMUNITY_TOPICS_SUCCESS,
        topics,
      });
    } catch (ex) {
      dispatch({ type: actionTypes.FETCH_COMMUNITY_TOPICS_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};
